/* eslint-disable no-debugger */
// Version : 0.0.1
// Author : sathish
// LastEdit : sathish
// Last ADD :added General CompanyID
// MODIFIED DATE : 03-04-2026
import { takeLatest, put, all, call } from "redux-saga/effects";

import StaffActionTypes from "./staff.types";
import {
  staffDetailsAdd,
  staffDetailsUpdate,
  staffListGet,
  staffDetailsFetch,
  staffDetailsDelete,
  branchListDetails,
  departmentDropdownListDetails,
  managerDropdownListDetails,
  userTypeListDetails,
} from "./staff.service";

import {
  addStaffDetailsSuccess,
  addStaffDetailsFailure,
  addStaffDetailsResponseChanged,
  updateStaffDetailsSuccess,
  updateStaffDetailsFailure,
  updateStaffDetailsResponseChanged,
  getStaffListSuccess,
  getStaffListFailure,
  getStaffListResponseChanged,
  fetchStaffDetailsSuccess,
  fetchStaffDetailsFailure,
  fetchStaffDetailsResponseChanged,
  deleteStaffDetailsSuccess,
  deleteStaffDetailsFailure,
  deleteStaffDetailsResponseChanged,
  getBranchListDropdownSuccess,
  getBranchListDropdownResponseChanged,
  getUserTypeDropdownListFailure,
  getUserTypeDropdownListSuccess,
  getUserTypeDropdownListResponseChanged,
  getDepartmentDropdownListFailure,
  getDepartmentDropdownListSuccess,
  // getDepartmentDropdownListResponseChanged,
  getManagerDropdownListSuccess,
  getManagerDropdownListFailure,
  getManagerDropdownListResponseChanged,
  getdepartmentDropdownListResponseChanged,
} from "./staff.action";
import { encryptData } from "../../_common/enode-decode";

/** *********************  START GET STAFF LIST  ******************** */
export function* staffDetailsListGet({ payload }: any) {
  try {
    const key = "GetAllUserPaginationKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      InputSearch: payload.searchValueSet,
      Limit: payload.limit,
      InstanceName: payload.InstanceName,
      // v2: when truthy, the backend skips the isActive=1 guard so we
      // can find soft-deleted users and reactivate them.
      IncludeInactive: payload.IncludeInactive ? 1 : 0,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(staffListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getStaffListFailure(responseData.data));
    } else {
      yield put(getStaffListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getStaffListFailure(error));
  }
}

export function* resetGetStaffListResponse() {
  yield put(getStaffListResponseChanged());
}

export function* onGetStaffListDetails() {
  yield takeLatest(StaffActionTypes.GET_STAFF_LIST_START, staffDetailsListGet);
}

export function* onGetStaffListResponseReset() {
  yield takeLatest(
    StaffActionTypes.GET_STAFF_LIST_RESPONSE_RESET,
    resetGetStaffListResponse,
  );
}
/** *********************  END GET STAFF LIST ******************** */

/** *********************  START ADD STAFF DETAILS  ******************** */
export function* createStaff({ payload }: any) {
  try {
    const key = "CreateUserLoginKey";
    const jsonData = {
      UserName: payload.staffName,
      AgentID: payload.agentID,
      UserTypeID: payload.userTypeID,
      UserPhoneNo: payload.userPhoneNo,
      CompanyID: payload.CompanyID,
      UserPassword: payload.staffPassword,
      UserFullName: payload.userFullName,
      UserMotherMaidenName: payload.userMotherMaidenName,
      UserPhoto: payload.userPhoto,
      UserDOB: payload.userDOB,
      UserAuthCode: payload.userAuthCode,
      UserDeviceID: payload.userDeviceID,
      UserLatitude: payload.userLatitude,
      UserLongitude: payload.userLongitude,
      UserResignationDate: payload.userResignationDate,
      UserAddress1: payload.userAddress1,
      UserAddress2: payload.userAddress2,
      City: payload.city,
      State: payload.state,
      Country: payload.country,
      ZipCode: payload.zipcode,
      IsManager: payload.isManager === false ? "0" : "1",
      ManagerID: payload.managerID,
      CreatedBy: payload.UserID,
      CreatedUserName: payload.UserName,
      UserLastLoginOn: payload.userLastLoginOn,
      BranchID: payload.branchID,
      UserJoiningDate: payload.userJoiningDate,
      TemplateID: payload.templateID,
      DepartmentID: payload.departmentID,
      InstanceName: payload.InstanceName,
      GeneralCompanyID: payload.GeneralCompanyID,
      UserGender: payload.userGender,
      UserEmail: payload.userEmail,
      GeneralUserID: payload.GeneralUserID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(staffDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addStaffDetailsFailure(responseData.data));
    } else {
      yield put(addStaffDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addStaffDetailsFailure(error));
  }
}

export function* resetAddStaffResponse() {
  yield put(addStaffDetailsResponseChanged());
}

export function* onCreateStaffDetails() {
  yield takeLatest(StaffActionTypes.ADD_STAFF_DETAILS_START, createStaff);
}

export function* onCreateStaffResponseReset() {
  yield takeLatest(
    StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_RESET,
    resetAddStaffResponse,
  );
}
/** *********************  END ADD STAFF DETAILS ******************** */

/** *********************  START UPDATE STAFF DETAILS  ******************** */
export function* staffUpdate({ payload }: any) {
  try {
    const key = "UpdateUserLoginKey";
    const jsonData = {
      AgentID: payload.agentID,
      UserTypeID: payload.userTypeID,
      UserPhoneNo: payload.userPhoneNo,
      UserPassword: payload.staffPassword,
      UserFullName: payload.userFullName,
      UserMotherMaidenName: payload.userMotherMaidenName,
      UserPhoto: payload.userPhoto,
      UserDOB: payload.userDOB,
      UserJoiningDate: payload.userJoiningDate,
      UserResignationDate: payload.userResignationDate,
      UserAddress1: payload.userAddress1,
      UserAddress2: payload.userAddress2,
      City: payload.city,
      State: payload.state,
      Country: payload.country,
      ZipCode: payload.zipcode,
      BranchID: payload.branchID,
      IsManager: payload.isManager === false ? "0" : "1",
      ManagerID: payload.managerID,
      CreatedBy: payload.UserID,
      CompanyID: payload.CompanyID,
      ManagerName: payload.ManagerName,
      UpdatedBy: payload.UserID,
      UserID: payload.UserID,
      OldUserName: payload.OldUserName,
      UserName: payload.staffName,
      UpdatedUserName: payload.UserName,
      TemplateID: payload.templateID,
      DepartmentID: payload.departmentID,
      InstanceName: payload.InstanceName,
      GeneralCompanyID: payload.GeneralCompanyID,
      UserGender: payload.userGender,
      UserEmail: payload.userEmail,
      GeneralUserID: payload.GeneralUserID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(staffDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateStaffDetailsFailure(responseData.data));
    } else {
      yield put(updateStaffDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateStaffDetailsFailure(error));
  }
}

export function* resetUpdateStaffDetailsResponse() {
  yield put(updateStaffDetailsResponseChanged());
}

export function* onUpdateStaffDetails() {
  yield takeLatest(StaffActionTypes.UPDATE_STAFF_DETAILS_START, staffUpdate);
}

export function* onUpdateStaffResponseReset() {
  yield takeLatest(
    StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_RESET,
    resetUpdateStaffDetailsResponse,
  );
}
/** *********************  END UPDATE STAFF DETAILS ******************** */

/** *********************  START DELETE STAFF DETAILS  ******************** */
export function* staffDelete({ payload }: any) {
  try {
    const key = "DeleteUserLoginKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      DeletedByUserName: payload.UserName,
      DeletedBy: payload.UserID,
      UserID: payload.userID,
      UserName: payload.userName,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(staffDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteStaffDetailsFailure(responseData.data));
    } else {
      yield put(deleteStaffDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteStaffDetailsFailure(error));
  }
}

export function* resetDeleteStaffDetailsResponse() {
  yield put(deleteStaffDetailsResponseChanged());
}

export function* onDeleteStaffDetail() {
  yield takeLatest(StaffActionTypes.DELETE_STAFF_DETAILS_START, staffDelete);
}

export function* onDeleteStaffResponseReset() {
  yield takeLatest(
    StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_RESET,
    resetDeleteStaffDetailsResponse,
  );
}
/** *********************  END DELETE STAFF DETAILS ******************** */

/** *********************  START FETCH STAFF DETAILS  ******************** */
export function* fetchStaffData({ payload }: any) {
  try {
    const key = "FetchUserLoginKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      UserID: payload.edituserID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(staffDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchStaffDetailsFailure(responseData.data));
    } else {
      yield put(fetchStaffDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchStaffDetailsFailure(error));
  }
}

export function* resetFetchStaffDetailsResponse() {
  yield put(fetchStaffDetailsResponseChanged());
}

export function* onFetchStaffDetails() {
  yield takeLatest(StaffActionTypes.FETCH_STAFF_DETAILS_START, fetchStaffData);
}

export function* onFetchStaffResponseReset() {
  yield takeLatest(
    StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_RESET,
    resetFetchStaffDetailsResponse,
  );
}
/** *********************  END FETCH STAFF DETAILS  ******************** */

/** *********************  START BRANCH DROPDOWN LIST DETAILS  ******************** */
export function* listBranchDropdownData({ payload }: any) {
  try {
    const key = "GetAllBranchKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(branchListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchStaffDetailsFailure(responseData.data));
    } else {
      yield put(getBranchListDropdownSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchStaffDetailsFailure(error));
  }
}

export function* resetBranchListResponse() {
  yield put(getBranchListDropdownResponseChanged());
}

export function* onFetchBranchDetails() {
  yield takeLatest(
    StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_START,
    listBranchDropdownData,
  );
}

export function* onFetchBranchListResponseReset() {
  yield takeLatest(
    StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_RESET,
    resetBranchListResponse,
  );
}

/** *********************  END BRANCH DROPDOWN LIST DETAILS  ******************** */

/** *********************  START USERTYPE DROPDOWN LIST DETAILS  ******************** */
export function* listUserTypeDropdownData({ payload }: any) {
  try {
    const key = "GetAllUserTypeKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      UserTypeIDFetch: payload.userTypeIDFetch,
      Level: payload.Level,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userTypeListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getUserTypeDropdownListFailure(responseData.data));
    } else {
      yield put(getUserTypeDropdownListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getUserTypeDropdownListFailure(error));
  }
}

export function* resetUserTypeListResponse() {
  yield put(getUserTypeDropdownListResponseChanged());
}

export function* onFetchUserTypeDetails() {
  yield takeLatest(
    StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_START,
    listUserTypeDropdownData,
  );
}

export function* onFetchUserTypeListResponseReset() {
  yield takeLatest(
    StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_RESPONSE_RESET,
    resetUserTypeListResponse,
  );
}

/** *********************  END USERTYPE DROPDOWN LIST DETAILS  ******************** */

/** *********************  START DEPARTMENT DROPDOWN LIST DETAILS  ******************** */
export function* listDepartmentDropdownData({ payload }: any) {
  try {
    const key = "GetAllDepartmentKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(departmentDropdownListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getDepartmentDropdownListFailure(responseData.data));
    } else {
      yield put(getDepartmentDropdownListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getDepartmentDropdownListFailure(error));
  }
}

export function* resetDepartmentListResponse() {
  yield put(getdepartmentDropdownListResponseChanged());
}

export function* onFetchDepartmentDetails() {
  yield takeLatest(
    StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_START,
    listDepartmentDropdownData,
  );
}

export function* onFetchDepartmentListResponseReset() {
  yield takeLatest(
    StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_RESET,
    resetDepartmentListResponse,
  );
}

/** *********************  END DEPARTMENT DROPDOWN LIST DETAILS  ******************** */

/** *********************  START MANAGER DROPDOWN LIST DETAILS  ******************** */
export function* listManagerDropdownData({ payload }: any) {
  try {
    const key = "GetAllManagerDetailsKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(managerDropdownListDetails, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getManagerDropdownListFailure(responseData.data));
    } else {
      yield put(getManagerDropdownListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getManagerDropdownListFailure(error));
  }
}

export function* resetManagerListResponse() {
  yield put(getManagerDropdownListResponseChanged());
}

export function* onFetchManagerDetails() {
  yield takeLatest(
    StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_START,
    listManagerDropdownData,
  );
}

export function* onFetchManagerListResponseReset() {
  yield takeLatest(
    StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_RESPONSE_RESET,
    resetManagerListResponse,
  );
}

/** *********************  END MANAGER DROPDOWN LIST DETAILS  ******************** */

export function* staffMasterSaga() {
  yield all([
    call(onCreateStaffDetails),
    call(onCreateStaffResponseReset),
    call(onUpdateStaffDetails),
    call(onUpdateStaffResponseReset),
    call(onGetStaffListDetails),
    call(onGetStaffListResponseReset),
    call(onFetchStaffDetails),
    call(onFetchStaffResponseReset),
    call(onDeleteStaffDetail),
    call(onDeleteStaffResponseReset),
    call(onFetchBranchDetails),
    call(onFetchBranchListResponseReset),
    call(onFetchUserTypeDetails),
    call(onFetchUserTypeListResponseReset),
    call(onFetchDepartmentDetails),
    call(onFetchDepartmentListResponseReset),
    call(onFetchManagerDetails),
    call(onFetchManagerListResponseReset),
  ]);
}
